// removed by extract-text-webpack-plugin
module.exports = {"deviceInfoTab1":"_1Q5pI1EhdTX1bUfvjA1lej","label":"_2qdUdSDTbWxBxL6HVWv2QZ","value":"_2vwEEh3v2FjwjNjNrrGRv6","valueWrap":"_3zHlkiS6lOrVRYP89-UMmg","textContainer":"-SprXoCYMe--ebVFui3RO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceInfo/DeviceDetail.less
// module id = 1538
// module chunks = 0